import {Injectable} from '@angular/core';
import {Http, Headers, Response, RequestOptionsArgs} from '@angular/http';
import {Router, ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import {tap} from "rxjs/operators/tap";
import {HttpRequestService} from '../_common/http-request.service';

@Injectable()
export class ModulesService {
    constructor(private http: HttpRequestService, private router: Router) {
    }

    gets(parameters) {
        return this.http.get('getAllModules', parameters)
            .map(res => {
                return res.json();
            })
    }

    getsModulesFunctions(parameters: any) {
        return this.http.get(`modulesFunctions`, parameters)
            .map(res => {
                return res.json();
            })
    }

    activeModules(model: any) {
        return this.http.put(`activeModules`, model)
            .map(res => {
                return res.json();
            });
    }

    add(model: any) {
        return this.http.post(`addModulesFunctions`,
            model).map(res => {
            return res.json();
        });
    }

    edit(model: any) {
        return this.http.post(`editModule`,
            model).map(res => {
            return res.json();
        });
    }

    updateIsModulesFunctions(model: any) {
        return this.http.put(`updateIsModulesFunctions`, model)
            .map(res => {
                return res.json();
            });
    }

    get(id) {
        return this.http.get(`getModuleById?id=${id}`)
            .map(res => {
                return res.json();
            })
    }

    getModuleFunctionById(id) {
        return this.http.get(`getModuleFunctionById?id=${id}`)
            .map(res => {
                return res.json();
            })
    }

    getModules(): Observable<any[]> {
        return this.http.get(`getAll/modules`)
            .map(res => {
                return res.json()
            });
    }

    getAllModuleAndFeatureModuleWeb(): any {
        return this.http.get(`getAllModuleAndFeatureModuleWeb`)
            .map(res => {
                return res.json()
            });
    }

    getConstantModule(): any {
        return this.http.get(`constant/module`)
            .map(res => {
                return res.json()
            });
    }
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/modules.service.ts